/* eslint-disable */
export default {
  title: 'Ääni',
  input: 'Tulo',
  microphone: 'Mikrofoni',
  autoAdjustMicLevel: 'Säädä mikrofonin äänenvoimakkuutta automaattisesti',
  output: 'Lähtö',
  speakerSource: 'Kaiutinlähde',
  speakerVolume: 'Kaiuttimen äänenvoimakkuus',
  ringtoneSource: 'Soittoäänen ja ilmoitusten lähde',
  ringtoneVolume: 'Soittoäänen ja ilmoitusten äänenvoimakkuus',
  ringtones: 'Soittoäänet',
  noDevices: 'Ei laitteita',
  off: 'Pois päältä',
  noLabel: 'Tuntematon laite',
  stopRecordDescription:
    'Testaa mikrofonin äänitaso puhumalla jotain ({countDown} s)',
  stopPlaybackDescription: 'Toistetaan tallennettasi...',
  startRecordButton: 'Testaa mikrofonia',
  stopRecordButton: 'Lopeta tallentaminen',
  stopPlaybackButton: 'Pysäytä testi',
  startTestButton: 'Testaa kaiutinta',
  stopTestDescription: 'Toistetaan ääninäytettä...',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
